import { Component, Input } from '@angular/core';
import { Station } from '../../../../../../client/model/station';

@Component({
    selector: 'app-empty-workingarea-item',
    templateUrl: './empty-workingarea-item.component.html',
    styleUrls: ['./empty-workingarea-item.component.scss'],
    standalone: false
})
export class EmptyWorkingAreaItemComponent {

  @Input() station: Station;

  @Input() selected: boolean;

  constructor(
  ) {

  }

}
